import Icon from '../components/Icon.vue'

Icon.register({
  'piggy-bank': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 224H530.5C521.7 204 508.9 186.3 493.1 171.5L512 96H480C450.6 96 424.6 109.5 407 130.3 399.4 129.2 391.9 128 384 128H256C178.6 128 114.1 183 99.2 256H56C41.2 256 29.5 242.5 32.5 227.2 34.7 215.8 45.4 208 57 208H58C61.3 208 64 205.3 64 202V182C64 178.7 61.3 176 58 176 29.5 176 4.1 196.4 0.5 224.6-3.9 258.8 22.7 288 56 288H96C96 340.2 121.4 386.1 160 415.3V496C160 504.8 167.2 512 176 512H240C248.8 512 256 504.8 256 496V448H384V496C384 504.8 391.2 512 400 512H464C472.8 512 480 504.8 480 496V415.3C491.8 406.4 502.3 395.9 511.3 384H560C568.8 384 576 376.8 576 368V240C576 231.2 568.8 224 560 224zM432 288C423.2 288 416 280.8 416 272S423.2 256 432 256 448 263.2 448 272 440.8 288 432 288zM256 96H384C389.4 96 394.7 96.4 399.9 96.8 399.9 96.5 400 96.3 400 96 400 43 357 0 304 0S208 43 208 96C208 98.1 208.5 100.1 208.6 102.2 223.8 98.3 239.6 96 256 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/piggy-bank.js
// module id = ysiM
// module chunks = 144